import React from 'react';
const HomeAdmin=()=> {
    return (
        <div>
            <h2>Hi</h2>
        </div>
    )
}

export default HomeAdmin;
